import RiskHitFeatureBlock from './RiskHitFeatureBlock';
import { transmissionScaleGapReason } from './transmissionScaleGap';

/** Reserved feature strip with the reason the scale is absent. */
export default function TransmissionScalePlaceholder({ features, facts, hasScheduleAnchor = false }) {
  return (
    <RiskHitFeatureBlock title="Шкала передачи">
      <p className="flex h-full items-center text-sm leading-snug text-slate-600 dark:text-slate-300">
        {transmissionScaleGapReason(features, facts, { hasScheduleAnchor })}
      </p>
    </RiskHitFeatureBlock>
  );
}
